import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateVehicleStatus, UpdateVehicleStatus} from "../../types/api/guide/vehicleStatus.types";

export const vehicleStatusService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.vehicleStatus.getAll),

    create: (vehicleStatus: CreateVehicleStatus) =>
        apiCall.post(apiUrls.guide.vehicleStatus.create, vehicleStatus),

    update: (id: string, vehicleStatus: UpdateVehicleStatus) =>
        apiCall.put(apiUrls.guide.vehicleStatus.update(id), vehicleStatus),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.vehicleStatus.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.vehicleStatus.getById(id))
}